import React from 'react'
import PropTypes from 'prop-types'

import { BadgeButton, ButtonLink, Subheading, Notification } from '@offerzen/pinata-shame'

import BellIcon from '@offerzen/zenicon/BellIcon'
import PencilIcon from '@offerzen/zenicon/PencilIcon'
import TrashIcon from '@offerzen/zenicon/TrashIcon'
import styles from './styles'

const EducationItemPreview = ({ id, toggleEditing, deleteEducation, universityLabel, degreeLabel, metadataLabel, missingInformation }) => (
  <div key={id} className={styles.wrapper} data-test="education-preview">
    <div className={styles.heading}>
      <div>
        <Subheading className={styles.university}>{universityLabel}</Subheading>

        <div className={styles.metadata}>{metadataLabel}</div>
      </div>

      <BadgeButton
        ariaLabel={`delete ${universityLabel} - ${degreeLabel}`}
        onClick={deleteEducation}
        className={styles.badgeButton}
        icon={TrashIcon}
        theme="primary"
      />

      <BadgeButton
        ariaLabel={`edit ${universityLabel} - ${degreeLabel}`}
        icon={PencilIcon}
        theme="primary"
        onClick={() => toggleEditing(true)}
      />
    </div>

    <If condition={missingInformation}>
      <Notification className={styles.notification} icon={BellIcon} theme="warning">
        This record is missing required information.{' '}
        <ButtonLink label="Complete the record" onClick={() => toggleEditing(true)} theme="warning" className={styles.action} />
      </Notification>
    </If>
  </div>
)

EducationItemPreview.propTypes = {
  id: PropTypes.string.isRequired,
  universityLabel: PropTypes.string,
  degreeLabel: PropTypes.string,
  metadataLabel: PropTypes.string,
  missingInformation: PropTypes.bool,
  toggleEditing: PropTypes.func,
  deleteEducation: PropTypes.func,
}

export default EducationItemPreview
